export default "__VITE_ASSET__62527a7c__"